import { render, staticRenderFns } from "./SchoolAverages.vue?vue&type=template&id=5cc96900&scoped=true&"
import script from "./SchoolAverages.vue?vue&type=script&lang=js&"
export * from "./SchoolAverages.vue?vue&type=script&lang=js&"
import style0 from "./SchoolAverages.vue?vue&type=style&index=0&id=5cc96900&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc96900",
  null
  
)

export default component.exports